import React, { useEffect } from 'react';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import { AdBannerResponsive } from '../components/GoogleAdsense';
import ProductCarousel from '../components/affiliate/ProductCarousel';
import '../styles/pages/PrivacyPage.css';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'プライバシーポリシー | つむぎ';
  }, []);

  return (
    <AppLayout>
      <PageTitle
        title="プライバシーポリシー"
        subtitle="Privacy Policy"
        icon="🔒"
      />

      <div className="tsumugi-container py-6">
        <div className="tsumugi-card">
          <div className="privacy-content-wrapper">
            <p className="privacy-last-updated">
              最終更新日: 2026年1月
            </p>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                1. 基本方針
              </h2>
              <p className="privacy-text">
                「つむぎ」（以下「本サービス」）を運営する当事業者は、利用者の個人情報の保護を重要な責務と考え、
                個人情報保護法その他の関係法令を遵守し、適切な取り扱いを行います。
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                2. 収集する個人情報
              </h2>

              <h3 className="privacy-subsection-title">
                2.1 アカウント情報
              </h3>
              <ul className="privacy-list-with-margin">
                <li>メールアドレス</li>
                <li>パスワード（暗号化して保存）</li>
                <li>選択プラン情報（Free、Standard、Premium等）</li>
                <li>登録日時・最終ログイン日時</li>
                <li>利用規約同意日時</li>
              </ul>

              <h3 className="privacy-subsection-title">
                2.2 健康関連情報
              </h3>
              <ul className="privacy-list-with-margin">
                <li>年齢・性別</li>
                <li>橋本病の診断状況・診断時期</li>
                <li>症状・体調に関する情報</li>
                <li>食事の好み・アレルギー情報・制限事項</li>
                <li>ライフスタイルに関する情報</li>
                <li>血液検査データ（Standard プラン以上）</li>
              </ul>

              <h3 className="privacy-subsection-title">
                2.3 利用履歴情報
              </h3>
              <ul className="privacy-list-with-margin">
                <li>相談履歴・チャット履歴</li>
                <li>レシピ閲覧・保存履歴</li>
                <li>気分記録データ</li>
                <li>ログイン履歴・アクセスログ</li>
              </ul>

              <h3 className="privacy-subsection-title">
                2.4 決済情報
              </h3>
              <ul className="privacy-list">
                <li>クレジットカード情報（Pay.jpを通じて安全に処理され、当サービスでは保持しません）</li>
                <li>決済履歴・プラン変更履歴</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                3. 個人情報の利用目的
              </h2>
              <p className="privacy-text-with-margin">
                当サービスは、収集した個人情報を以下の目的で利用します。
              </p>
              <ul className="privacy-list-numbered">
                <li className="privacy-list-item-spaced">本サービスの提供・運営・改善</li>
                <li className="privacy-list-item-spaced">ユーザーの健康状態・体調に合わせた個別化された栄養アドバイスの提供</li>
                <li className="privacy-list-item-spaced">ユーザーサポート・問い合わせ対応</li>
                <li className="privacy-list-item-spaced">利用規約違反の調査・対応</li>
                <li className="privacy-list-item-spaced">サービスの利用状況分析・統計データの作成（個人を特定できない形式）</li>
                <li className="privacy-list-item-spaced">新機能・キャンペーン・アップデート情報の通知</li>
                <li className="privacy-list-item-spaced">決済処理・課金管理</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                4. 個人情報の第三者提供
              </h2>
              <p className="privacy-text-with-margin">
                当サービスは、以下の場合を除き、ユーザーの個人情報を第三者に提供することはありません。
              </p>
              <ul className="privacy-list">
                <li className="privacy-list-item-spaced">ユーザーの同意がある場合</li>
                <li className="privacy-list-item-spaced">法令に基づく場合</li>
                <li className="privacy-list-item-spaced">人の生命、身体または財産の保護のために必要がある場合であって、ユーザーの同意を得ることが困難である場合</li>
                <li className="privacy-list-item-spaced">国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
              </ul>
            </section>

            <AdBannerResponsive />

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                5. 個人情報の安全管理
              </h2>
              <p className="privacy-text-with-margin">
                当サービスは、個人情報の漏えい、滅失または毀損の防止その他の個人情報の安全管理のために、以下の措置を講じています。
              </p>
              <ul className="privacy-list">
                <li className="privacy-list-item-spaced">SSL/TLS暗号化通信の採用</li>
                <li className="privacy-list-item-spaced">パスワードのハッシュ化（bcrypt使用）</li>
                <li className="privacy-list-item-spaced">データベースのアクセス制御・権限管理</li>
                <li className="privacy-list-item-spaced">定期的なセキュリティ監査・脆弱性チェック</li>
                <li className="privacy-list-item-spaced">クレジットカード情報の非保持（PCI DSS準拠のPay.jpを使用）</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                6. Cookieおよび類似技術の使用
              </h2>
              <p className="privacy-text-with-margin">
                本サービスは、ユーザー体験の向上、ログイン状態の維持、アクセス解析のために、Cookieおよび類似技術を使用します。
              </p>
              <p className="privacy-text">
                ブラウザの設定により、Cookieを無効化することも可能ですが、一部機能が正常に動作しない場合があります。
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                7. 個人情報の開示・訂正・削除
              </h2>
              <p className="privacy-text-with-margin">
                ユーザーは、当サービスに対して、個人情報保護法の定めに基づき、自己の個人情報の開示、訂正、削除等を請求することができます。
              </p>
              <ul className="privacy-list">
                <li className="privacy-list-item-spaced"><strong>プロフィール情報の確認・変更:</strong> マイページ > プロフィール編集</li>
                <li className="privacy-list-item-spaced"><strong>アカウント削除:</strong> マイページ > アカウント削除</li>
                <li className="privacy-list-item-spaced"><strong>その他のお問い合わせ:</strong> チャット機能またはメールにてご連絡ください</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                8. プライバシーポリシーの変更
              </h2>
              <p className="privacy-text">
                当サービスは、必要に応じて、本プライバシーポリシーを変更することがあります。
                変更後のプライバシーポリシーは、本ページに掲載した時点で効力を生じるものとします。
                重要な変更がある場合は、サービス内での通知またはメールにてお知らせします。
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                9. お問い合わせ
              </h2>
              <p className="privacy-text">
                本プライバシーポリシーに関するお問い合わせは、サービス内のチャット機能またはお問い合わせフォームよりご連絡ください。
              </p>
            </section>

            <section className="privacy-section">
              <h2 className="privacy-section-title">
                10. 事業者情報
              </h2>
              <ul className="privacy-list">
                <li><strong>事業者名:</strong> PinkRose</li>
                <li><strong>代表者:</strong> 松山義征</li>
                <li><strong>所在地:</strong> 〒106-0044 東京都港区東麻布2-35-1 KCビル6F</li>
                <li><strong>連絡先:</strong> hashimoto@pink-rose.info</li>
              </ul>
            </section>

            <p className="privacy-footer-text">
              以上
            </p>
          </div>
        </div>
        <AdBannerResponsive />
        <ProductCarousel location="privacy" />
      </div>
    </AppLayout>
  );
};

export default PrivacyPage;
